module.exports = __webpack_public_path__ + "img/login3.b6ecbafa.png";